import styled from '@xstyled/styled-components';
import Select from 'react-select';
import { useAtom } from 'jotai';
import { sortAtom } from 'global/store';
import { sortOptions } from 'global/data';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'next-i18next';



const StyledSelect = styled(Select)`
  flex: 1;
  z-index: 2;
`;

export default function SortSelect() {
  const [sort, setSort] = useAtom(sortAtom);
  const router = useRouter();
  const { t } = useTranslation();

  useEffect(()=> {
    setSort(sortOptions[`${router.locale}`].content)
  }, [])
  const handleSortSelect = selection => setSort(selection);

  return (
    <StyledSelect
      name="sort"
      placeholder={t('ui.choose')}
      options={sortOptions[`${router.locale}`].content}
      defaultValue={sortOptions[`${router.locale}`].content[0]}  
      value={sort}
      onChange={handleSortSelect}
      styles={{
        control: base => ({
          ...base,
          width: '170px',
          borderRadius: '10px',
          background: '#FCFCFC',
          boxShadow: 'none',
          border: '2px solid #A8A9BA',
          '&:focus': {
            border: '2px solid #A8A9BA'
          },
          '&:hover': {
            border: '2px solid #A8A9BA'
          },

          '@media (max-width: 1024px)': {
            border: 'none',
            background: 'white',
            '&:focus': {
              border: 'none'
            },
            '&:hover': {
              border: 'none'
            }
          }
        }),
        indicatorSeparator: () => ({
          display: 'none'
        }),
        dropdownIndicator: (base, state) => ({
          ...base,
          transform: state.selectProps.menuIsOpen
            ? 'scale(1.4) rotate(180deg)'
            : 'scale(1.4)',
          color: '#393939',
          cursor: 'pointer',
          transition: 'all 0.5s',
          '&:hover': {
            color: 'inherit'
          }
        }),
        option: (base, state) => ({
          ...base,
          background: state.isSelected ? '#F6F6FF' : 'white',
          color: 'black',
          cursor: 'pointer',
          '&:hover': {
            background: '#F6F6FF',
            color: 'black'
          }
        }),
        menuList: base => ({
          ...base,
          paddingTop: '0',
          paddingBottom: '0'
        })
      }}
    />
  );
}
